import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateFormatService } from 'src/app/shared/services/date-format.service';
import { MomentService } from 'src/app/shared/services/moment.service';

@Component({
  selector: 'app-einvoice-date-input',
  templateUrl: './einvoice-date-input.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceDateInputComponent),
      multi: true
    }
  ]
})
export class EInvoiceDateInputComponent implements ControlValueAccessor {
  @Input() value: any;
  @Input() disabled = false;
  @Input() nzDisabled = false;
  @Input() maxLength: string | number | null = null;
  @Input() borderless = false;
  @Input() nzAllowClear = false;
  @Input() placeHolder: string = ' ';
  @Input() showTime = false;
  /**
   * Optional override for display format (DatePipe/NZ format string).
   * If not provided, we'll use the user's Date Format setting for the date portion.
   */
  @Input() format?: string;

  date: Date | null = null;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayFormat(): string {
    if (this.format) return this.format;

    const dateFmt = this.dateFormatService.currentDateFormatValue;
    if (this.showTime) {
      // Apply user-selected date format, keep time format unchanged.
      return `${dateFmt} HH:mm:ss`;
    }
    return dateFmt;
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(
    private dateSrv: MomentService,
    public dateFormatService: DateFormatService,
    private cdr: ChangeDetectorRef
  ) {
  }

  writeValue(value: any): void {
    if (value) {
      this.date = this.showTime ? value : this.dateSrv.toDateStart(value);
    } else {
      this.date = null;
    }
    this.value = this.showTime ? value : this.formatDate();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    if (val) {
      this.date = this.showTime ? val : this.dateSrv.toDateStart(val);
    } else this.date = null;
    this.value = this.showTime ? val : this.formatDate();
    this.onChange(this.value);
    this.cdr.markForCheck();
  }

  onOk(val: any) {
    if (val) {
      this.date = this.showTime ? val : this.dateSrv.toDateStart(val);
    } else this.date = null;
    this.value = this.showTime ? val : this.formatDate();
    this.onChange(this.value);
    this.cdr.markForCheck();
  }

  formatDate() {
    if (this.date) {
      const year = this.date.getFullYear();
      const month = this.date.getMonth() + 1;
      const day = this.date.getDate();
      const format = `${year}-${month}-${day}`;
      return format;
    }
    return null;
  }
}
